<template>
  <div class="fv-row mb-7 fv-plugins-icon-container" :style="{'display': inline ? 'inline-block' : '', 'margin': inline ? '0px 4px' : ''}">
    <label class="fs-6 fw-semibold form-label mt-3" v-show="!nolabel">
      <span :class="{'required': required}">
        {{ (label) ? label : 'Sem Label' }} 
        <span v-if="opcional" class="text-muted">
          • (Opcional)
        </span>
      </span>
    </label>
    <select 
      class="form-select form-control form-control-solid" 
      autocomplete="false" 
      v-model="valor" 
      :aria-label="(label) ? label : 'Sem Label'" 
      :disabled="disabled" 
      ref="inputSelect" 
      :style="{'width': width, 'padding': padding, 'font-size': fontsize, 'background-size': fontsize}"
    >
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option v-for="item in items" :key="item.value" :value="item.value">{{ item.text }}</option>
    </select>
    <div class="fv-plugins-message-container invalid-feedback"></div>
  </div>
</template>

<script>

export default {
  name: "InputSelect",
  data() {
    return {};
  },
  computed: {
    valor: {
      get() {
        return this.modelValue !== undefined ? this.modelValue : this.value;
      },
      set(newValue) {
        if(this.$talklogos) {
          this.$emit("input", newValue);
        } else {
          this.$emit("update:modelValue", newValue);
        }
      }
    }
  },
  props: [
    "modelValue", 
    "label", 
    "items", 
    "disabled", 
    "required", 
    "placeholder", 
    "multiple", 
    "nolabel", 
    "opcional",
    "value", 
    "width", 
    "padding", 
    "fontsize", 
    "inline"
  ],
  methods: {
    setFocus() {
      this.$refs.inputSelect.focus();
    }    
  }
};
</script>

<style scoped>

</style>
